import { compactWordKeyMap, ECompactWordType } from '@/axios/company';
import { Checkbox, Collapse, Flex, Space } from 'antd';
import styles from './index.module.less';
import { ObjectKeys } from '@/utils';
import { CollapseProps } from 'antd/es';
import { useEffect, useState } from 'react';
import BaseCollapse from '@/components/Base/Collapse';
const CompactWordCollapse = ({
  compactWords,
  searchPhrase,
  setSearchPhrase,
  excludeType,
}: {
  compactWords?: { [key in ECompactWordType]: string[] };
  searchPhrase: { [key in ECompactWordType]: string[] };
  setSearchPhrase: (phrase: { [key in ECompactWordType]: string[] }) => void;
  excludeType?: ECompactWordType;
}) => {
  const getInitialIndeterminate = (
    searchPhrase: { [key in ECompactWordType]: string[] },
    compactWords?: { [key in ECompactWordType]: string[] }
  ): { [key in ECompactWordType]: boolean } => {
    const result: { [key in ECompactWordType]: boolean } = {
      [ECompactWordType.QuestionPrefix]: false,
      [ECompactWordType.LocationPrefix]: false,
      [ECompactWordType.RecommendPrefix]: false,
      [ECompactWordType.BrandPrefix]: false,
      [ECompactWordType.ScenePrefix]: false,
      [ECompactWordType.EntitySuffix]: false,
      [ECompactWordType.RecommendSuffix]: false,
      [ECompactWordType.QuestionAnswerSuffix]: false,
      [ECompactWordType.Core]: false,
    };
    if (!compactWords) return result;
    (ObjectKeys(compactWords)).forEach((key) => {
      const total = compactWords[key]?.length || 0;
      const selected = searchPhrase[key]?.length || 0;
      result[key] = selected > 0 && selected < total;
    });
    return result;
  };
  const [indeterminate, setIndeterminate] = useState<{
    [key in ECompactWordType]: boolean;
  }>(getInitialIndeterminate(searchPhrase, compactWords));
  useEffect(() => {
    setIndeterminate(getInitialIndeterminate(searchPhrase, compactWords));
  }, [searchPhrase, compactWords]);
  const filteredCompactWords = excludeType
    ? (Object.fromEntries(
        (Object.entries(compactWords || {}) as [ECompactWordType, string[]][]).filter(([key]) => key !== excludeType)
      ) as { [key in ECompactWordType]: string[] })
    : compactWords;
  // 要按照compactWords的顺序来
  const items: CollapseProps['items'] = (Object.keys(filteredCompactWords || {}) as ECompactWordType[]).map((key) => {
    const options = (compactWords?.[key] || []).map((word) => ({ label: word, value: word }));
    const label = compactWordKeyMap[key];
    return {
      key,
      forceRender: true,
      label: (
        <Space onClick={(e) => e.stopPropagation()}>
          <Checkbox
            indeterminate={indeterminate[key]}
            checked={
              searchPhrase[key]?.length === (compactWords?.[key]?.length || 0) &&
              (compactWords?.[key]?.length || 0) > 0
            }
            onChange={(e) => {
              e.stopPropagation();
              const optionValues = options.map((option) => option.value);
              if (e.target.checked) {
                setIndeterminate((prev) => ({ ...prev, [key]: false }));
                const newSearchPhrase = { ...searchPhrase };
                newSearchPhrase[key] = optionValues;
                setSearchPhrase(newSearchPhrase);
              } else {
                setIndeterminate((prev) => ({ ...prev, [key]: optionValues.some((value) => !value) }));
                const newSearchPhrase = { ...searchPhrase };
                newSearchPhrase[key] = [];
                setSearchPhrase(newSearchPhrase);
              }
            }}
          />
          <div>{`${label} (${(compactWords?.[key] || []).length})`}</div>
        </Space>
      ),
      children: (
        <Checkbox.Group
          options={options}
          value={searchPhrase[key]}
          onChange={(checkedValues) => {
            setIndeterminate((prev) => ({ ...prev, [key]: checkedValues.length > 0 && checkedValues.length < options.length }));
            const newSearchPhrase = { ...searchPhrase };
            newSearchPhrase[key] = checkedValues as string[];
            setSearchPhrase(newSearchPhrase);
          }}
        />
      ),
    };
  });
  return <BaseCollapse panelColor="#fff" dividerColor="rgba(0, 0, 0, 0.07)" items={items} defaultActiveKey={items.map((item) => item.key as string)[0]} />;
};

// 渲染组合词
const renderCompactWords = (
  rules: {
    [key in ECompactWordType]: string[];
  },
  options?: {
    excludeType?: ECompactWordType;
    showEmpty?: boolean;
  }
) => {
  const { excludeType, showEmpty = true } = options || {};
  return (Object.entries(rules) as [ECompactWordType, string[]][]).map(([type, words]) => {
    if (type === excludeType) {
      return null;
    }
    if (!showEmpty && words.length === 0) {
      return null;
    }
    return (
      <Flex gap={8} key={type} className={styles.word_item}>
        <div className={styles.word_type}>
          【{compactWordKeyMap[type]}({words.length})】：
        </div>
        <div className={styles.word_text}>{words.length === 0 ? '无' : words.join('、')}</div>
      </Flex>
    );
  });
};
export { renderCompactWords, CompactWordCollapse };
